import { css } from "@emotion/css";
import { IconButton, StepCount } from "@octopusdeploy/design-system-components";
import { borderRadius, space, text, themeTokens } from "@octopusdeploy/design-system-tokens";
import * as React from "react";
import { useState } from "react";
import { Action } from "~/analytics/Analytics";
import { SampleProjectTourContext } from "~/areas/projects/components/ProjectLayout/SampleProjectTour/SampleProjectTour";
import { useRequiredContext } from "~/hooks/index";
function SampleProjectTourResume() {
    const sampleProjectTourContext = useRequiredContext(SampleProjectTourContext);
    const [isHovered, setIsHovered] = useState<boolean>();
    const onResumeTourClicked = () => {
        sampleProjectTourContext.resumeTour();
        sampleProjectTourContext.dispatchAnalyticsEventForCurrentState("Sample Project Tour: Click Resume Tour", Action.Resume, "SampleProjectTourResume");
    };
    const onDismissTourClicked = () => {
        sampleProjectTourContext.dismissTour();
        sampleProjectTourContext.dispatchAnalyticsEventForCurrentState("Sample Project Tour: Click 'X' to Dismiss Resume Tour", Action.Dismiss, "SampleProjectTourResume");
    };
    const shouldRender = sampleProjectTourContext.tourState === "Suspended";
    if (!shouldRender) {
        return null;
    }
    return (<div role="button" className={styles.container} onClick={onResumeTourClicked} onMouseEnter={() => setIsHovered(true)} onMouseLeave={() => setIsHovered(false)}>
            <StepCount variant="circular" currentStep={sampleProjectTourContext.stepIndex + 1} totalSteps={sampleProjectTourContext.totalStepCount}/>
            <div className={styles.textContainer}>
                <div className={styles.text}>Resume Tour</div>
                {isHovered && <DismissPrompt onDismissClicked={onDismissTourClicked}/>}
            </div>
        </div>);
}
export interface DismissPromptProps {
    onDismissClicked: () => void;
}
export function DismissPrompt(props: DismissPromptProps) {
    const onDismissClicked = (event: React.MouseEvent) => {
        event.stopPropagation();
        props.onDismissClicked();
    };
    return (<div>
            <IconButton accessibleName="CloseSampleProjectTour" icon={"XmarkIcon"} onClick={onDismissClicked}/>
        </div>);
}
const styles = {
    container: css({
        display: "flex",
        alignItems: "center",
        justifyContent: "space-between",
        width: "100%",
        padding: space[8],
        borderRadius: borderRadius.small,
        border: "0px",
        cursor: "pointer",
        color: themeTokens.color.callout.text.info,
        backgroundColor: themeTokens.color.callout.background.info.default,
        "&:hover": {
            backgroundColor: themeTokens.color.callout.background.info.hover,
        },
        "&:active": {
            backgroundColor: themeTokens.color.callout.background.info.pressed,
        },
    }),
    textContainer: css({
        display: "flex",
        alignItems: "center",
        justifyContent: "space-between",
        width: "100%",
    }),
    text: css({
        marginLeft: space[8],
        font: text.body.bold.large,
    }),
};
export default SampleProjectTourResume;
